import HomeContainer from '../containers/home/HomeContainer';

export default function HomePage() {
    return (
        <HomeContainer />
    );
}
